// @flow
import * as React from 'react'
import styled, { css } from 'styled-components'
import Theme from 'ui/theme'

type Props = {
  children: any,
  xlarge?: boolean,
  muted?: boolean,
}

const StyledText = styled.p`
  ${({ xlarge }: Props) => {
    if (xlarge) {
      return css`
        font-size: ${Theme.fontSize.xlarge};
      `
    }

    return css`
      font-size: ${Theme.fontSize.default};
    `
  }}
  ${({ muted }: Props) =>
    muted
      ? css`
          color: ${Theme.color.mutedText};
        `
      : css``}
`

const Text = ({ children, ...props }: Props): React$Element<any> => {
  return <StyledText {...props}>{children}</StyledText>
}

export default Text
